import apiClient from "./apiClient";

function getCurrentUser(authKey) {
  return apiClient("base").post("/getCurrentUser", undefined, authKey);
}

export default {
  getCurrentUser,
};
